$(document).ready(function(){
  // Product respiclear pdp

  console.log('Launched respiclear');

  $('.mp_atc_btn_checkout').click(function(evt) {
  evt.preventDefault();

  const currentId = $('.variants-bundles__option').find('input:checked').attr('data-id');
  let sellingId = null;

  if ($('#auto_refill').prop('checked')) {
    sellingId = $('.variants-bundles__option').find('input:checked').attr('data-selling-plan');
  }

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  const $btn = $(this);
  $btn.attr('aria-disabled', true).addClass('loading');
  $btn.find('.loading-overlay__spinner').removeClass('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append('id', currentId);
  formData.append('quantity', 1);
  if (sellingId) formData.append('selling_plan', sellingId);

  if (cart) {
    formData.append(
      'sections',
      cart.getSectionsToRender().map(section => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(document.activeElement);
  }

  config.body = formData;

  // Clear the cart first, then add the new product
  fetch('/cart/clear.js', { method: 'POST' })
    .then(() => fetch(`${routes.cart_add_url}`, config))
    .then(response => response.json())
    .then(response => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'mp_atc_btn',
          productVariantId: currentId,
          errors: response.errors || response.description,
          message: response.message,
        });
        return;
      }

      window.location.href = '/checkout';
    })
    .catch((e) => {
      console.error('Add to cart error:', e);
      alert('Something went wrong.');
    })
    .finally(() => {
      $btn.removeClass('loading').removeAttr('aria-disabled');
      $btn.find('.loading-overlay__spinner').addClass('hidden');
    });
});


  $('.custom_atc_button').click(function(){
      var currentId = $(this).attr('data-id');
      var mode = $(this).attr('data');
      var sellingPlanId = $(this).attr('data-sub-id');

      var gifts = $(this).attr('data-gifts');
      
      console.log(mode, 'MODE');
      
      if (mode == 'sub'){
        if (gifts == '1'){
          var items = [];
          items.push({ id: currentId, quantity: 1, selling_plan: sellingPlanId });
          items.push({ id: 42287700934774, quantity: 1 });
          // items.push({ id: 50236538224918, quantity: 1 });
          // items.push({ id: 50236537569558, quantity: 1 });

          console.log(items, 'ITEMS');
          
          $.ajax({
              type: "POST",
              url: "/cart/clear.js",
              success: function () {
                  $.ajax({
                      type: "POST",
                      url: "/cart/add.js",
                      data: {
                        items: items,
                      },
                      success: function () {
                          window.location.href = '/checkout';
                      }
                  });
              }
          });
        }
        else{
          $.ajax({
              type: "POST",
              url: "/cart/clear.js",
              success: function () {
                  $.ajax({
                      type: "POST",
                      url: "/cart/add.js",
                      data: {
                          id: currentId,
                          quantity: 1,
                          selling_plan: sellingPlanId
                      },
                      success: function () {
                          window.location.href = '/checkout';
                      }
                  });
              }
          });
        }
      }
      else{
          
        $.ajax({
              type: "POST",
              url: "/cart/clear.js",
              success: function () {
                  $.ajax({
                      type: "POST",
                      url: "/cart/add.js",
                      data: {
                          id: currentId,
                          quantity: 1
                      },
                      success: function () {
                          window.location.href = '/checkout';
                      }
                  });
              }
          });

          
      }
  });

  $('.mp_atc_btnv3').click(function(evt) {
    evt.preventDefault();
  
    // Get variant ID and optional selling plan
    
    let sellingId = null;
    var currentId;
  
     var data;

    if ($('#auto_refillv2').prop('checked')) {
      sellingId = $('.variants-bundles__option.v2opts').find('input:checked').attr('data-selling-plan');
      currentId = $('.variants-bundles__option.v2opts').find('input:checked').attr('data-id');
      data = {
        id: currentId,
        quantity: 1,
        selling_plan: sellingId,
      };
    }
    else{
      currentId = $('.variants-bundles__option.v2opts').find('input:checked').attr('data-otp-id');
      data = {
        id: currentId,
        quantity: 1
      };
    }

    
    console.log(data);
    jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function() {
         
            window.location.href = '/checkout';
        },
        error: function() {
            alert('Error adding item to the cart.');
            
        }
    });
  });

  $('.variants-bundles__option input').change(function () {
    setTimeout(function () {

      // cache the checked input
      var $checked = $('.variants-bundles__option input:checked');

      // get normal ID
      var currentId = $checked.attr('data-id');

      // if OTP ID exists → override
      var otpId = $checked.attr('data-otp-id');
      if (otpId) {
        currentId = otpId;
      }

      // update span visibility
      $('.autofill_span-element').addClass('hided');
      $('.autofill_span-element[data-id="' + currentId + '"]').removeClass('hided');

    }, 100);
  });


  
  $('.mp_atc_btn').click(function (evt) {
     evt.preventDefault();
      const currentBlock = $('.product-selector_outer.active_block').find('.product-selector_block.active');
      const currentId = $('.variants-bundles__option').find('input:checked').attr('data-id');
      let sellingId = null;

      if ($('#auto_refill').prop('checked')) {
        sellingId = $('.variants-bundles__option').find('input:checked').attr('data-selling-plan');
      }

      var items = [];
      var currentQty = 1;



      items.push({ id: currentId , quantity: currentQty, selling_plan: sellingId });

      $('.product_selector-var-ros[data-id="'+currentId+'"]').find('.product_selector-gift-real-id_ros').each(function(){
        var currentId = $(this).attr('data-id');
        var currentQty = 1;
        items.push({ id: currentId , quantity: currentQty});
      });

      // currentBlock.find('.product_selector-gift-real-id').each(function(){
      //   var currentId = $(this).attr('data-id');
      //   var currentQty = 1;
      //   items.push({ id: currentId , quantity: currentQty});
      // });

      jQuery.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            items: items
          },
          dataType: "json",
          success: function() {
            window.refreshCartDrawer();
            $('.cd_outer').show();
            setTimeout(function () {
                $('.cd_outer').addClass('active');
            }, 100);
          },
          error: function() {
          }
      });
  });

    
//   $('.mp_atc_btn').click(function(evt) {
//   evt.preventDefault();

//   // Get variant ID and optional selling plan
//   const currentId = $('.variants-bundles__option').find('input:checked').attr('data-id');
//   let sellingId = null;

//   if ($('#auto_refill').prop('checked')) {
//     sellingId = $('.variants-bundles__option').find('input:checked').attr('data-selling-plan');
//   }

//   const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

//   const $btn = $(this);
//   $btn.attr('aria-disabled', true).addClass('loading');
//   $btn.find('.loading-overlay__spinner').removeClass('hidden');

//   const config = fetchConfig('javascript');
//   config.headers['X-Requested-With'] = 'XMLHttpRequest';
//   delete config.headers['Content-Type'];

//   const formData = new FormData();
//   formData.append('id', currentId);
//   formData.append('quantity', 1);
//   if (sellingId) formData.append('selling_plan', sellingId);

//   if (cart) {
//     formData.append(
//       'sections',
//       cart.getSectionsToRender().map(section => section.id)
//     );
//     formData.append('sections_url', window.location.pathname);
//     cart.setActiveElement(document.activeElement);
//   }

//   config.body = formData;

//   fetch(`${routes.cart_add_url}`, config)
//     .then((response) => response.json())
//     .then((response) => {
//       if (response.status) {
//         publish(PUB_SUB_EVENTS.cartError, {
//           source: 'mp_atc_btn',
//           productVariantId: currentId,
//           errors: response.errors || response.description,
//           message: response.message,
//         });
//         return;
//       }

//       if (!cart) {
//         window.location = window.routes.cart_url;
//         return;
//       }

//       // Update and open the slide cart
//       publish(PUB_SUB_EVENTS.cartUpdate, {
//         source: 'mp_atc_btn',
//         productVariantId: currentId,
//         cartData: response
//       });

//       cart.renderContents(response);
//       $('.drawer').removeClass('is-empty'); // just in case

//     })
//     .catch((e) => {
//       console.error('Add to cart error:', e);
//       alert('Something went wrong.');
//     })
//     .finally(() => {
//       $btn.removeClass('loading').removeAttr('aria-disabled');
//       $btn.find('.loading-overlay__spinner').addClass('hidden');
//     });
// });



  // $('.mp_atc_btn').click(function(evt){
  //   evt.preventDefault();

  //   var currentId = $('.variants-bundles__option').find('input:checked').attr('data-id');
  //   var sellingId = 'none';
  //   if ($('#auto_refill').prop('checked')) {
  //     var sellingId = $('.variants-bundles__option').find('input:checked').attr('data-selling-plan');
  //   } 

    // var data;

    // if (sellingId == 'none'){
    //   data = {
    //     id: currentId,
    //     quantity: 1
    //   };
    // }
    // else{
    //   data = {
    //     id: currentId,
    //     quantity: 1,
    //     selling_plan: sellingId,
    //   };
    // }
    
    // console.log(data);
    
    // jQuery.ajax({
    //     type: "POST",
    //     url: "/cart/add.js",
    //     data: data,
    //     dataType: "json",
    //     success: function() {
    //         window.location.href = '/checkout';
    //     },
    //     error: function() {
    //         alert('Error adding item to the cart.');
            
    //     }
    // });
  // });

  $('.main-product_accordion_box').click(function(){
    $(this).find('.main-product__accordion_content').slideToggle();
    $(this).toggleClass('active');
  });

  $('.mp-gallery_carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    asNavFor:".mp-gallery_carousel_thumbs"
  });

  $('.mp-gallery_carousel_thumbs').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    asNavFor:".mp-gallery_carousel",
    focusOnSelect: true
  });

  $('.mp-reviews_box').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true
  });

  $('.respiclear_ingredients-list.Mobile_only').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '30px',
    arrows: false,
    dots: true
  });

  $('.rql_cell').click(function(){
    $(this).find('.rql_content').slideToggle();
    $(this).toggleClass('active');
  });


  $('.respiclear_btn-primary').click(function(evt){
    evt.preventDefault();
     $('html, body').animate({
          scrollTop: $(".main-product_section").offset().top
      }, 500);
  });


  const homepageReviewsSwiper = new Swiper('.homepage-reviews-swiper', {
    
  scrollbar: {
      el: ".homepage-reviews-swiper-scrollbar",
  },

  pagination: {
      el: ".homepage-reviews-pagination-button .swiper-pagination",
      type: "custom",
      renderCustom: function (swiper, current, total) {
          return (swiper.activeIndex + 1).toString() + '/' + document.querySelectorAll('.homepage-reviews-swiper .swiper-slide').length;
      }
  },

  navigation: {
      nextEl: '.homepage-reviews-pagination-button .swiper-button-next',
      prevEl: '.homepage-reviews-pagination-button .swiper-button-prev'
  },

  breakpoints: {
      320: {
          centeredSlides: true,
          slidesPerView: 1.26,
          spaceBetween: 14,
          loop: true
      },
      768: {
          slidesPerView: 2.3,
          spaceBetween: 15,
      },
      992: {
          centeredSlides: false,
          slidesPerView: 3,
          spaceBetween: 32,
          loop: false
      },
      1200: {
          slidesPerView: 3,
          spaceBetween: 32,
      },
      1500: {
          slidesPerView: 3,
          spaceBetween: 32,
      },
      1920: {
          slidesPerView: 3,
          spaceBetween: 32,
      }
  }
});

  
});